/* eslint-disable max-params */
/* eslint-disable complexity */
import _ from 'lodash';

/**
 * 格式化数字，3个数字一组，用逗号分隔
 * @param value
 * @returns 格式化后的数字
 */
export function formatNumber(value: number) {
    return new Intl.NumberFormat('en-US', { style: 'decimal' }).format(value);
}

/**
* 格式化数值大小, 输出成带单位的字符串
* @param {Number} num 数值大小
* @param {Number} [digits=2] 精确到的小数点数。
* @param {Number} [toThousands=true] 千分位逗号分隔。
*/
export function formatNumberByKilo2(num: number, digits = 2, toThousands = true) {
    // 处理符号
    let sign = '';
    if (num < 0) {
        sign = '-';
        num = -num;
    }
    // 处理数据
    const si = [
        { value: 1, symbol: '' },
        { value: 1E3, symbol: 'K' },
        { value: 1E6, symbol: 'M' },
        { value: 1E9, symbol: 'B' },
        { value: 1E12, symbol: 'T' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
        if (num >= si[i].value) {
            break;
        }
    }
    let n = (num / si[i].value).toFixed(digits).replace(rx, '$1');

    if (toThousands) {
        // 处理小数点
        // eslint-disable-next-line prefer-const
        let [left, right] = n.toString().split('.');
        left = left.replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,');
        n = _.compact([left, right]).join('.');
    }

    const u = si[i].symbol;
    return sign + n + u;
}
